/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-12-27 10:15:01
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { ChromePicker } from 'react-color';

export class RenderColorPicker2 extends Component<Props> {
  render() {
    const { color, input, disableAlpha = false } = this.props;

    return (
      <div className="reviewRatingsPicker">
        <ChromePicker
          id={input.name}
          color={color}
          onChangeComplete={input.onChange}
          disableAlpha={disableAlpha}
        />
      </div>
    );
  }
}
